import "./src/styles/global.css";
import "./src/styles/algolia.css";
import "./src/styles/markdown.css";
import "./src/styles/jsfiles.css";
import wrapWithProvider, { msalInstance } from "./src/wrap-with-provider";
import { startClsReporter } from "./src/utils/clsReporter";
import { identifyClarityUser } from "./src/utils/clarityIdentify";
export const wrapRootElement = wrapWithProvider;
// 既存の Service Worker が新しい版に更新されたときだけ再読み込みする。
// onServiceWorkerUpdateFound は初回インストール時にも呼ばれるため、初回訪問のたびに
// 表示直後のページが再読み込みされてしまう。
export const onServiceWorkerUpdateReady = () => window.location.reload();
export const onClientEntry = () => startClsReporter();
export const onRouteUpdate = () =>
  identifyClarityUser(msalInstance.getAllAccounts()[0]);
